var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReference = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h3.172c.331 0 .649.132.883.366L7.47 14.53a.75.75 0 0 0 1.06 0l1.415-1.414a1.25 1.25 0 0 1 .883-.366H14a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75h-3.172c-.729 0-1.428.29-1.944.805L8 3.94l-.884-.883a2.75 2.75 0 0 0-1.944-.806zm.75 9v-7.5h2.422c.331 0 .649.132.883.366L7.25 5.311v6.878l-.134-.133a2.75 2.75 0 0 0-1.944-.806zm6 .94.134-.135a2.75 2.75 0 0 1 1.944-.805h2.422v-7.5h-2.422a1.25 1.25 0 0 0-.883.366L8.75 5.311z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReference);
export default ForwardRef;